import classNames from "classnames";
import update from "react-addons-update";
import SVG from "react-inlinesvg/esm";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import SettingsPanel from "../../SettingsPanel";
import { useAppStore } from "../../stores/appStore";
import { useProjectStore } from "../../stores/projectStore";
import { Button } from "../Button";
import HelpMenu from "../HelpMenu";
import SleekChangelog from "../SleekChangelog";
import { Container } from "./styles";

export default function Menu({
  subscription, //
  userData,
  setSettingsOpen,
  settingsOpen,
  demo,
  setDemo,
  subscriptionJSON,
  editorOptions,
  setEditorOptions,
  sleekToken,
  setHelpOpen,
  helpOpen,
  statusText = null, // ability to pass in a status text shown left of the components
  floating = false,
  hideLabs = false,
  hideHelp = false,
  hideHiring = false,
  hideNew = false,
  hideBackButton = false,
  showFront,
  isLoading = false,
}) {
  const location = useLocation();
  const isSW2 = useAppStore((state) => state.isSW2);
  const project = useProjectStore((state) => state.project);

  if (isSW2 && (project?.id || location.pathname.startsWith("/app/project"))) {
    return null;
  }

  return (
    <Container className="menu-component-container main-menu">
      <div className={classNames("inner", { floating })}>
        <div className="right">
          {userData && userData.fetched && subscription && subscription.fetched && (
            <SettingsPanel
              setOpen={setSettingsOpen}
              open={settingsOpen}
              demo={demo}
              setDemo={(d) => {
                setDemo(d);
              }}
              subscription={subscriptionJSON}
              font={editorOptions.font}
              fontSize={editorOptions.fontSize}
              textIndent={editorOptions.textIndent}
              lineHeight={editorOptions.lineHeight}
              paragraphSpacing={editorOptions.paragraphSpacing}
              showWordCount={editorOptions.showWordCount}
              wormholeOutputLength={editorOptions.wormholeOutputLength}
              wormholeOutputCards={editorOptions.wormholeOutputCards}
              creativitySliderPosition={editorOptions.creativitySliderPosition}
              theme={editorOptions.theme}
              showCreditsUsedToast={editorOptions.showCreditsUsedToast}
              onSubmit={(data) => {
                setEditorOptions(update(editorOptions, { $merge: data }));
              }}
            />
          )}

          {!isLoading && (
            <div className="membership-status">
              <div className="message">
                <span>
                  {statusText && <div className="status-text">{statusText}</div>}

                  {!hideHiring && (
                    <a
                      className="pill-link"
                      href="https://bit.ly/3ZO6mpj"
                      target="_blank"
                    >
                      🚀 We're hiring!
                    </a>
                  )}

                  {!hideNew && <SleekChangelog />}

                  {!hideLabs && (
                    <div className="labs-link-container">
                      <Link
                        to="/app/labs"
                        className="labs-link"
                      >
                        <Button
                          className="use-component-styles"
                          aria-label="Labs"
                          secondaryGrey={true}
                          iconSize={24}
                        >
                          <SVG src="/assets/labs-icon.svg" />
                        </Button>
                      </Link>
                    </div>
                  )}
                  {!hideHelp && (
                    <HelpMenu
                      sleekToken={sleekToken}
                      setOpen={setHelpOpen}
                      open={helpOpen}
                      subscription={subscriptionJSON}
                      showFront={showFront}
                    />
                  )}
                </span>
              </div>
            </div>
          )}
        </div>

        <div className="doc-list">
          {!hideBackButton && (
            <Link to={location.state?.from || "/app"}>
              <Button
                className="use-component-styles"
                aria-label="Home"
                secondaryGrey={true}
                iconSize={24}
              >
                <SVG
                  className="icon-button"
                  src="/assets/back-arrow.svg"
                />
              </Button>
            </Link>
          )}
        </div>

        <div className="clear"></div>
      </div>
    </Container>
  );
}
